export const DEV_ENV_KEY = 'dev';

export default () => (window.REACT_APP_ENV || import.meta.env.REACT_APP_ENV) === DEV_ENV_KEY;
